import { defineMessages } from "react-intl";

const messages = defineMessages({
  addCommentButton: {
    defaultMessage: "Add comment",
  },
  artistCaption: {
    defaultMessage: "Artist",
  },
  errorMessage: {
    defaultMessage:
      "Sorry, we're having trouble loading comments at this time. Please try again soon.",
  },
  joinTheConversation: {
    defaultMessage: "Join the conversation!",
  },
  leaveAComment: {
    defaultMessage: "Leave a comment",
  },
  loginSignupLink: {
    defaultMessage: "Sign up or log in",
  },
  newCommentErrorMessage: {
    defaultMessage: "Sorry, we couldn't post your comment. Please try again.",
  },
  replyLink: {
    defaultMessage: "Reply",
  },
  showArtistLove: {
    defaultMessage: "Give the artist some ❤️",
  },
  showArtistAppreciation: {
    defaultMessage: "Add a comment and show the artist your appreciation.",
  },
  deletingCommentErrorMessage: {
    defaultMessage: "Sorry, we couldn't delete your comment. Please try again.",
  },
});

export default messages;
